export var AppTileElementIdPrefix = 'Shell';
export var AppTileElementIdPrefixLength = AppTileElementIdPrefix.length;
export var AppsShimDataSourceAppCollectors = 3;
export var AppsShimDataSourceShellDataComplete = 4;
//# sourceMappingURL=Constants.js.map